export enum MentionPermissions {
  MENTION_EXTERNALLY = 'CREATE_EXTERNAL_MENTION',
}
